import { URL, handleErrors } from "./depannageActions"
import { catchApiError } from "./apiHelpers"

// Droits d'accès par module, RÉSOLUS PAR LE SERVEUR (source unique :
// backend/svp/access.py). Le front n'embarque plus de table de droits — il lit
// cette map. Rechargée à chaque boot de l'app : contrairement aux `groups`
// figés dans le localStorage à la connexion, un changement de matrice ne
// demande pas de reconnexion.
export const FETCH_ACCESS_BEGIN = "FETCH_ACCESS_BEGIN"
export const FETCH_ACCESS_SUCCESS = "FETCH_ACCESS_SUCCESS"
export const FETCH_ACCESS_ERROR = "FETCH_ACCESS_ERROR"

export const fetchAccessBegin = () => ({ type: FETCH_ACCESS_BEGIN })

// `payload` porte la réponse complète d'api/access : les modules de la matrice
// de droits ET les catégories de notifications du user (résolues serveur —
// l'éligibilité est éditable en base, cf. Configuration → Notifications).
export const fetchAccessSuccess = (payload) => ({
	type: FETCH_ACCESS_SUCCESS,
	payload,
})

export const fetchAccessError = (error) => ({
	type: FETCH_ACCESS_ERROR,
	payload: error,
})

export function fetchAccess() {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		if (!token) return Promise.resolve()
		dispatch(fetchAccessBegin())
		return fetch(`${URL}api/access`, {
			headers: { Authorization: `Bearer ${token}` },
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(
					fetchAccessSuccess({
						modules: json.modules || [],
						notifCategories: json.notif_categories || [],
					}),
				)
				return json
			})
			.catch(catchApiError(dispatch, fetchAccessError))
	}
}
